import { render } from "./view_role.vue?vue&type=template&id=1842a31c&lang=html"
import script from "./view_role.vue?vue&type=script&lang=js"
export * from "./view_role.vue?vue&type=script&lang=js"

import "./view_role.vue?vue&type=style&index=0&id=1842a31c&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__